<div class="np-scrollable h-100">
    <dx-data-grid
        class="h-100"
        [dataSource]="model?.yearlySellThroughFigures"
        [allowColumnReordering]="true"
        [rowAlternationEnabled]="true"
        [allowColumnResizing]="true"
        noDataText="{{ 'keine Abverkaufszahlen' | translate }}"
        [showBorders]="true"
    >
        <dxi-column
            dataField="year"
            caption="{{'Jahr' | translate }}"
            cellTemplate="yearTpl"
        ></dxi-column>
        <div *dxTemplate="let stf of 'yearTpl'">
            <np-inputControl
                [(model)]="model"
                [dragFilter]="dragFilter"
                [suppressLabel]="true"
                [showPlaceLabel]="stf.data.year != null"
                [selectedElements]="selectedElements"
                field="YEAR"
                [system]="stf.data.year.toString()"
                (elementSelected)="templateSelect($event, stf.data.year.toString())"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-number-box
                        [(value)]="stf.data.year"
                        [readOnly]="true"
                    ></dx-number-box>
                </div>
            </np-inputControl>
        </div>

        <dxi-column
            dataField="marketVolume"
            caption="{{ 'Marktmenge' | translate }}"
            cellTemplate="marketVolumeTpl"
        ></dxi-column>
        <div *dxTemplate="let stf of 'marketVolumeTpl'">
            <np-inputControl
                [(model)]="model"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                [suppressLabel]="true"
                [showPlaceLabel]="stf.data.marketVolume != null"
                [selectedElements]="selectedElements"
                field="MARKET_VOLUME"
                [system]="stf.data.year.toString()"
                (elementSelected)="templateSelect($event, stf.data.year.toString())"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-number-box
                        [(value)]="stf.data.marketVolume"
                        [readOnly]="true"
                    ></dx-number-box>
                </div>
            </np-inputControl>
        </div>

        <dxi-column
            dataField="sellThroughVolume"
            caption="{{'Abverkaufsmenge' | translate }}"
            cellTemplate="sellThroughVolumeTpl"
        ></dxi-column>
        <div *dxTemplate="let stf of 'sellThroughVolumeTpl'">
            <np-inputControl
                [(model)]="model"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                [suppressLabel]="true"
                [showPlaceLabel]="stf.data.sellThroughVolume != null"
                [selectedElements]="selectedElements"
                field="SELLTHROUGH_VOLUME"
                [system]="stf.data.year.toString()"
                (elementSelected)="templateSelect($event, stf.data.year.toString())"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-number-box
                        [(value)]="stf.data.sellThroughVolume"
                        [readOnly]="true"
                    ></dx-number-box>
                </div>
            </np-inputControl>
        </div>

        <dxi-column
            dataField="participantCount"
            caption="{{'Anzahl Teilnehmer' | translate }}"
            cellTemplate="participantCountTpl"
        ></dxi-column>
        <div *dxTemplate="let stf of 'participantCountTpl'">
            <np-inputControl
                [(model)]="model"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                [suppressLabel]="true"
                [showPlaceLabel]="stf.data.participantCount != null"
                [selectedElements]="selectedElements"
                field="PARTICIPANT_COUNT"
                [system]="stf.data.year.toString()"
                (elementSelected)="templateSelect($event, stf.data.year.toString())"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-number-box
                        [(value)]="stf.data.participantCount"
                        [readOnly]="true"
                    ></dx-number-box>
                </div>
            </np-inputControl>
        </div>

        <dxi-column
            dataField="marketCount"
            caption="{{'Anzahl Märkte' | translate }}"
            cellTemplate="marketCountTpl"
        ></dxi-column>
        <div *dxTemplate="let stf of 'marketCountTpl'">
            <np-inputControl
                [(model)]="model"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                [suppressLabel]="true"
                [showPlaceLabel]="stf.data.marketCount != null"
                [selectedElements]="selectedElements"
                field="MARKET_COUNT"
                [system]="stf.data.year.toString()"
                (elementSelected)="templateSelect($event, stf.data.year.toString())"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-number-box
                        [(value)]="stf.data.marketCount"
                        [readOnly]="true"
                    ></dx-number-box>
                </div>
            </np-inputControl>
        </div>

        <dxi-column
            dataField="averageSellThroughPerParticipant"
            [caption]="'Ø ' + ('Abverkauf pro Teilnehmer' | translate)"
            cellTemplate="avgPerParticipantTpl"
        ></dxi-column>
        <div *dxTemplate="let stf of 'avgPerParticipantTpl'">
            <np-inputControl
                [(model)]="model"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                [suppressLabel]="true"
                [showPlaceLabel]="stf.data.averageSellThroughPerParticipant != null"
                [selectedElements]="selectedElements"
                field="AVERAGE_SELLTHROUGH_PER_PARTICIPANT"
                [system]="stf.data.year.toString()"
                (elementSelected)="templateSelect($event, stf.data.year.toString())"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-number-box
                        [(value)]="stf.data.averageSellThroughPerParticipant"
                        [readOnly]="true"
                    ></dx-number-box>
                </div>
            </np-inputControl>
        </div>

        <dxi-column
            dataField="averageSellThroughPerMarket"
            [caption]="'Ø ' + ('Abverkauf pro Markt' | translate)"
            cellTemplate="avgPerMarketTpl"
        ></dxi-column>
        <div *dxTemplate="let stf of 'avgPerMarketTpl'">
            <np-inputControl
                [(model)]="model"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                [suppressLabel]="true"
                [showPlaceLabel]="stf.data.averageSellThroughPerMarket != null"
                [selectedElements]="selectedElements"
                field="AVERAGE_SELLTHROUGH_PER_MARKET"
                [system]="stf.data.year.toString()"
                (elementSelected)="templateSelect($event, stf.data.year.toString())"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-number-box
                        [(value)]="stf.data.averageSellThroughPerMarket"
                        [readOnly]="true"
                    ></dx-number-box>
                </div>
            </np-inputControl>
        </div>
    </dx-data-grid>
</div>
